module.exports = __webpack_public_path__ + "img/1w.db038ec2.svg";